import { clients } from 'lib/https';
import { getConfigurationSettings } from 'services/configuration-service';

import type {
  IBasePromptLibraryResponse,
  ICreatePromptFolderPayload,
  ICreatePromptPayload,
  IDeletePromptFolderPayload,
  IDeletePromptPayload,
  IGetPromptFoldersResponse,
  IListPromptsPayload,
  IListPromptsResponse,
  IUpdatePromptFolderPayload,
  IUpdatePromptPayload,
} from '../types/prompt-library.service.type';

export class PromptLibraryService {
  async getFolders(
    projectKey: string,
    blocksKey: string,
    ownerId: string,
    limit = 100,
    offset = 0
  ): Promise<IGetPromptFoldersResponse> {
    const config = await getConfigurationSettings();
    const params = new URLSearchParams({
      project_key: projectKey,
      owner_id: ownerId,
      limit: String(limit),
      offset: String(offset),
    });
    const url = `${config.paths.seliseAiBaseUrl}${config.paths.seliseAi.promptLibraryFoldersList}?${params.toString()}`;
    return clients.get(url, blocksKey);
  }

  async createFolder(payload: ICreatePromptFolderPayload, blocksKey: string): Promise<IBasePromptLibraryResponse> {
    const config = await getConfigurationSettings();
    return clients.post(
      `${config.paths.seliseAiBaseUrl}${config.paths.seliseAi.promptLibraryFolderCreate}`,
      blocksKey,
      JSON.stringify(payload)
    );
  }

  async updateFolder(payload: IUpdatePromptFolderPayload, blocksKey: string): Promise<IBasePromptLibraryResponse> {
    const config = await getConfigurationSettings();
    return clients.post(
      `${config.paths.seliseAiBaseUrl}${config.paths.seliseAi.promptLibraryFolderUpdate}`,
      blocksKey,
      JSON.stringify(payload)
    );
  }

  async deleteFolder(payload: IDeletePromptFolderPayload, blocksKey: string): Promise<IBasePromptLibraryResponse> {
    const config = await getConfigurationSettings();
    return clients.post(
      `${config.paths.seliseAiBaseUrl}${config.paths.seliseAi.promptLibraryFolderDelete}`,
      blocksKey,
      JSON.stringify(payload)
    );
  }

  async listPrompts(payload: IListPromptsPayload, blocksKey: string): Promise<IListPromptsResponse> {
    const config = await getConfigurationSettings();
    return clients.post(
      `${config.paths.seliseAiBaseUrl}${config.paths.seliseAi.promptLibraryPromptsList}`,
      blocksKey,
      JSON.stringify(payload)
    );
  }

  async createPrompt(payload: ICreatePromptPayload, blocksKey: string): Promise<IBasePromptLibraryResponse> {
    const config = await getConfigurationSettings();
    return clients.post(
      `${config.paths.seliseAiBaseUrl}${config.paths.seliseAi.promptLibraryPromptCreate}`,
      blocksKey,
      JSON.stringify(payload)
    );
  }

  async updatePrompt(payload: IUpdatePromptPayload, blocksKey: string): Promise<IBasePromptLibraryResponse> {
    const config = await getConfigurationSettings();
    return clients.post(
      `${config.paths.seliseAiBaseUrl}${config.paths.seliseAi.promptLibraryPromptUpdate}`,
      blocksKey,
      JSON.stringify(payload)
    );
  }

  async deletePrompt(payload: IDeletePromptPayload, blocksKey: string): Promise<IBasePromptLibraryResponse> {
    const config = await getConfigurationSettings();
    return clients.post(
      `${config.paths.seliseAiBaseUrl}${config.paths.seliseAi.promptLibraryPromptDelete}`,
      blocksKey,
      JSON.stringify(payload)
    );
  }
}

export const promptLibraryService = new PromptLibraryService();
